export default "__VITE_ASSET__0twKE0tF__"